// Hộp kết quả sau khi thanh toán: mã đơn, tiền thối chữ lớn, In K80 / In A4 / Gửi Zalo / Đơn mới
import { Modal, message } from 'antd';
import { CheckCircle2, FileText, Plus, Printer, Send } from 'lucide-react';
import type { Order } from '../data';
import usePosStore from '../store';
import { currentUserName, formatPhone, money, printReceipt, usePosAuth } from '../utils';

interface Props {
  orderId: string | null;
  change: number;
  onNewOrder: () => void;
  primaryLabel?: string;
}

export default function PaymentSuccessModal({ orderId, change, onNewOrder, primaryLabel = 'ĐƠN MỚI' }: Props) {
  const order = usePosStore(s => s.orders.find(o => o.id === orderId)) as Order | undefined;
  const logOrder = usePosStore(s => s.logOrder);
  const { can } = usePosAuth();

  const sendZalo = () => {
    if (!order) return;
    if (!order.customerPhone) {
      message.warning('Khách lẻ không có số điện thoại để gửi Zalo');
      return;
    }
    logOrder(order.id, currentUserName(), `Gửi hóa đơn qua Zalo tới ${formatPhone(order.customerPhone)}`);
    message.success(`Đã gửi hóa đơn qua Zalo tới ${formatPhone(order.customerPhone)} (mô phỏng)`);
  };

  return (
    <Modal open={!!order} footer={null} closable={false} maskClosable={false} centered width={520} keyboard={false}>
      {order && (
        <div className="py-2 text-center">
          <CheckCircle2 className="mx-auto h-14 w-14 text-green-600" />
          <h2 className="mt-2 text-xl font-bold text-slate-800">{order.debt > 0 ? 'Đã lưu đơn – còn nợ' : 'Thanh toán thành công'}</h2>
          <p className="mt-1 font-mono text-sm text-slate-500">{order.id}</p>
          <div className="mt-4 grid grid-cols-2 gap-3 text-left">
            <div className="rounded-xl bg-slate-50 p-3">
              <div className="text-xs text-slate-500">Tổng đơn</div>
              <div className="text-xl font-bold text-slate-800">{money(order.totals.total)}đ</div>
            </div>
            <div className={`rounded-xl p-3 ${order.debt > 0 ? 'bg-amber-50' : 'bg-green-50'}`}>
              <div className="text-xs text-slate-500">{order.debt > 0 ? 'Còn nợ' : 'Tiền thối'}</div>
              <div className={`text-3xl font-extrabold ${order.debt > 0 ? 'text-amber-600' : 'text-green-600'}`}>{money(order.debt > 0 ? order.debt : change)}đ</div>
            </div>
          </div>
          <div className="mt-5 grid grid-cols-3 gap-2">
            <button disabled={!can('print')} onClick={() => printReceipt(order, 'K80', { change })} className="flex h-12 items-center justify-center gap-2 rounded-lg border border-slate-300 bg-white text-sm font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50">
              <Printer className="h-4 w-4" /> In K80
            </button>
            <button disabled={!can('print')} onClick={() => printReceipt(order, 'A4', { change })} className="flex h-12 items-center justify-center gap-2 rounded-lg border border-slate-300 bg-white text-sm font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50">
              <FileText className="h-4 w-4" /> In A4
            </button>
            <button onClick={sendZalo} className="flex h-12 items-center justify-center gap-2 rounded-lg border border-slate-300 bg-white text-sm font-semibold text-slate-700 hover:bg-slate-50">
              <Send className="h-4 w-4" /> Gửi Zalo
            </button>
          </div>
          <button autoFocus onClick={onNewOrder} className="mt-3 flex h-14 w-full items-center justify-center gap-2 rounded-lg bg-[#357f96] text-base font-bold text-white hover:bg-[#2c6b7f]">
            <Plus className="h-5 w-5" /> {primaryLabel}
          </button>
        </div>
      )}
    </Modal>
  );
}
